import { MAX_TOOL_RESULT_CHARS } from './agentLoop.js';

const CONTINUE_RE = /^(continue|continua|continuar)\.?$/i;

function clip(text, max = MAX_TOOL_RESULT_CHARS) {
  const s = String(text ?? '');
  return s.length > max ? `${s.slice(0, max)}\n...[truncated]` : s;
}

function toolSummary(m = {}) {
  const metadata = m.metadata && typeof m.metadata === 'object' ? m.metadata : {};
  const tool = metadata.tool || m.tool_name || 'tool';
  const status = metadata.status || m.status || 'done';
  const path = metadata.path ? ` ${metadata.path}` : '';
  const header = `Resultado anterior de ferramenta (${tool}${path}, status=${status}):`;
  const body = m.result ?? metadata.summary ?? m.content ?? '';
  return `${header}\n${clip(body)}`;
}

/** Last substantive user request before a bare "continue". */
export function findLastUserTask(messages = []) {
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    const m = messages[i];
    if (!m || m.role !== 'user') continue;
    const text = String(m.content || '').trim();
    if (!text || CONTINUE_RE.test(text)) continue;
    return text;
  }
  return null;
}

/** Expand bare "continue" into an explicit resume instruction. */
export function expandContinuePrompt(text, messages = []) {
  const raw = String(text || '').trim();
  if (!CONTINUE_RE.test(raw)) return raw;
  const lastTask = findLastUserTask(messages);
  if (!lastTask) return raw;
  return `Continue executando esta tarefa sem pedir clarificação. Retome exatamente de onde parou:\n${lastTask}`;
}

// Rebuild the model-facing history from persisted/live UI messages.
// Important: "continue" turns need tool observations from the previous run;
// otherwise the model only sees the user/assistant text and may redo exploration.
export function buildAgentHistory(messages = []) {
  let out = [];
  for (const m of messages || []) {
    if (!m || typeof m !== 'object') continue;
    // /compact (DeerFlow) — o marker RESETA o histórico modelo-facing: tudo antes
    // dele vira o digest; o feed visível (que renderiza todas as msgs) fica intacto.
    if (m.metadata?.kind === 'context_summary') {
      out = [{
        role: 'user',
        content: `Contexto compactado da conversa até aqui (use como memória do que já foi feito):\n${String(m.metadata.summary || '')}`,
      }];
      continue;
    }
    if (m.role === 'user') {
      out.push({ role: 'user', content: String(m.content || '') });
    } else if (m.role === 'assistant' || m.role === 'agent') {
      out.push({ role: 'assistant', content: String(m.content || '') });
    } else if (m.role === 'tool') {
      out.push({ role: 'user', content: toolSummary(m) });
    }
  }
  return out.filter((m) => m.content.trim());
}
